import { IObjectFieldProps } from "../index";
import Button from "@mui/material/Button";
import { ButtonGroup } from "@mui/material";
import { useEffect, useState } from "react";
import * as auto_pi from "@crochik/auto-pi";
import { PreviewFormDialog } from "./EditFormDialog";
import { FormDesignerDialog } from "./FormDesigner";
import { toJS } from "mobx";

export function FormObjectField(props: IObjectFieldProps) {
    const { form, field, value } = props;
    const { isReadOnly: formReadOnly } = form;
    const { isReadOnly: fieldReadOnly } = field;
    const isReadOnly = formReadOnly || fieldReadOnly;
    const [formModel, setFormModel] = useState<auto_pi.Form>();
    const [isPreviewVisible, showPreview] = useState(false);
    const [isDesignerVisible, showDesigner] = useState(false);

    useEffect(() => {
        if (value) {
            const form = (toJS(value) ?? {}) as auto_pi.Form;
            form.Layouts ??= {};
            form.Fields ??= [];
            setFormModel(form);
        } else {
            setFormModel(undefined);
        }
    }, [value]);

    const onPreview = () => {
        if (!formModel) return;

        showPreview(true);
    };

    const onEdit = () => {
        if (!formModel) {
            const form = (toJS(value) ?? {}) as auto_pi.Form;
            form.Name ??= field.name ?? "New Form";
            form.Title ??= field.label ?? field.name ?? "New Form";
            form.Layouts ??= {};
            form.Fields ??= [];
            setFormModel(form);
        }

        showDesigner(true);
    };

    const onClosePreview = () => {
        showPreview(false);
    };

    const onCloseDesigner = (layouts: any) => {
        if (!formModel) return;

        // update layouts 
        formModel.Layouts = toJS(layouts);
        form.setValue(field, formModel);

        showDesigner(false);
    };

    if (!formModel) {
        if (isReadOnly) return null;
        return (
            <div style={{ }} >
                <Button onClick={onEdit}>Add</Button>
            </div>
        );
    }

    const { Name, Title, Fields } = formModel;

    return (
        <>
            <div style={{ paddingTop: 12, paddingBottom: 12 }}>
                <div>{Title ?? Name}</div>
                {!!Title && Name !== Title && <div>{Name}</div>}
                {Fields && <div>{Fields.length} Field(s)</div>}
                {/*{actions && <div>{actions.length} Action(s)</div>}*/}

                <ButtonGroup>
                    <Button onClick={onPreview}>Preview</Button>
                    <Button onClick={onEdit}>Edit</Button>
                    {/* {!isReadOnly && <Button>Edit</Button>} */}
                </ButtonGroup>
            </div>
            {isPreviewVisible && <PreviewFormDialog onClose={onClosePreview} form={formModel} raw={value!} />}
            {isDesignerVisible && <FormDesignerDialog onClose={onCloseDesigner} initialForm={formModel} />}
        </>
    );
}